module.exports = __webpack_public_path__ + "static/kuaishou-765c2b2a8257b0f0aa30cf106306aeec.png";